import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {AuthenticationService} from './authentication.service';
import {LicenzeService} from './licenze.service';
import {constants} from '../_helpers/constants';
import {AiChatAmbitoContesto} from '../_models/ai-chat.model';

/** Feature 164: richiesta di aprire il pannello su una nuova conversazione di contesto. */
export interface AiChatRichiestaContesto {
  ambito: AiChatAmbitoContesto;
  orgId: number;
  /** Testo attuale presente: la domanda iniziale chiede di migliorarlo invece di scriverlo. */
  migliora: boolean;
}

/** Feature 159: apertura del pannello della chat AI, condivisa tra il bottone nell'header (presente in
 * ogni pagina) e il pannello unico in `app.component.html`. */
@Injectable({providedIn: 'root'})
export class AiChatPanelService {
  private readonly apertoSubject = new BehaviorSubject<boolean>(false);
  readonly aperto$ = this.apertoSubject.asObservable();
  private readonly contestoSubject = new Subject<AiChatRichiestaContesto>();
  readonly contesto$ = this.contestoSubject.asObservable();
  private readonly authService = inject(AuthenticationService);
  private readonly licenzeService = inject(LicenzeService);

  get aperto(): boolean {
    return this.apertoSubject.value;
  }

  /** Operatore autenticato, licenza `AI-BASE-CHAT` sull'organizzazione corrente e ruolo `CHAT`. */
  get disponibile(): boolean {
    return !!this.authService.currentUserValue?.jwtToken
      && this.licenzeService.checkPermesso(constants.MOD_AI_BASE_CHAT)
      && this.authService.isInRole(constants.ROLE_CHAT);
  }

  apri() {
    if (this.disponibile) this.apertoSubject.next(true);
  }

  /** «Genera/Migliora con l'assistente» dall'editor dei contesti: apre il pannello e chiede la conversazione. */
  apriContesto(richiesta: AiChatRichiestaContesto) {
    if (!this.disponibile) return;
    this.apri();
    this.contestoSubject.next(richiesta);
  }

  chiudi() {
    this.apertoSubject.next(false);
  }

  alterna() {
    if (this.aperto) this.chiudi(); else this.apri();
  }
}
